import { PropertyChangedInformation, Notification } from '@app/shared';

@Notification({
    name: 'RoomUpdatedNotification'
})
export class RoomUpdatedNotification {
    public roomId: string;
    public roomName: string | null;
    public changes: PropertyChangedInformation[] = [];
}

@Notification({
    name: 'RoomCreatedNotification'
})
export class RoomCreatedNotification {
    public roomId: string;
    public roomName: string | null;
    public changes: PropertyChangedInformation[] = [];
}
